import React from 'react'
import { MapPin, Link } from 'lucide-react'
import { MeetingDescriptionEditor } from './MeetingDescriptionEditor'

interface IMeetingDetailsFormProps {
  // Location
  location: string
  onLocationChange: (location: string) => void

  // Meeting Link
  meetingLink: string
  onMeetingLinkChange: (link: string) => void
  linkCopied: boolean
  onCopyLink: () => void

  // Description
  description: string
  onDescriptionChange: (description: string) => void
}

export const MeetingDetailsForm: React.FC<IMeetingDetailsFormProps> = ({
  location,
  onLocationChange,
  meetingLink,
  onMeetingLinkChange,
  linkCopied,
  onCopyLink,
  description,
  onDescriptionChange,
}) => {
  return (
    <>
      {/* Location */}
      <div className="mb-5">
        <label className="block text-sm font-medium text-primary-text mb-2">Location</label>
        <div className="flex items-center border border-primary-outline rounded-md px-3 py-2">
          <MapPin className="w-4 h-4 mr-2 opacity-70" />
          <input
            type="text"
            value={location}
            onChange={(e) => onLocationChange(e.target.value)}
            placeholder="Add location or meeting room"
            className="flex-1 text-sm outline-none bg-transparent"
          />
        </div>
      </div>

      {/* Meeting Link */}
      <div className="mb-5">
        <label className="block text-sm font-medium text-primary-text mb-2">Meeting Link</label>
        <div className="flex items-center border border-primary-outline rounded-md px-3 py-2">
          <Link className="w-4 h-4 mr-2 opacity-70" />
          <input
            type="text"
            value={meetingLink}
            onChange={(e) => onMeetingLinkChange(e.target.value)}
            placeholder="Enter meeting link..."
            className="flex-1 bg-transparent text-sm text-primary-text outline-none"
          />
          <button
            onClick={onCopyLink}
            disabled={!meetingLink.trim()}
            className={`text-sm font-medium transition-colors pl-2 ${
              linkCopied
                ? 'text-green-600'
                : meetingLink.trim()
                ? 'text-primary hover:underline'
                : 'text-silver-light cursor-not-allowed'
            }`}
          >
            {linkCopied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>

      {/* Description */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-primary-text mb-2">
          Description and Additional Details
        </label>
        <MeetingDescriptionEditor value={description} onChange={onDescriptionChange} />
      </div>
    </>
  )
}
